import React from 'react';
import * as R from 'ramda';
import { utcToZonedTime, format } from 'date-fns-tz/fp';
import { Box, Typography } from '@mui/material';
import { column } from './commonCSS';
import { isAfter } from 'date-fns';

const currentTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;

const formatDate = date =>
	R.compose(
		format('yyyy-MM-dd'),
		x => x /*?*/,
		utcToZonedTime(currentTimeZone)
	)(date);

const normalizeStatus = R.replace('_', ' ');

function getStatusInfoFromSchedule({ status, phases }) {
	return {
		status: normalizeStatus(status),
		start_date: formatDate(new Date(phases[0].start_date * 1000))
	};
}

function getStatusInfoFromSubscription({ status, start_date }) {
	return {
		status: normalizeStatus(status),
		start_date: formatDate(new Date(start_date * 1000))
	};
}

export function getStatusInfoFromSubscriptionOrSchedule(data) {
	return data.object === 'subscription_schedule'
		? getStatusInfoFromSchedule(data)
		: getStatusInfoFromSubscription(data);
}

export const StatusValue = ({ label, value, sx }) => {
	return (
        <Box
			sx={[column, {
				alignItems: 'flex-end',
				...sx
			}]}>
            <Typography component="label" variant="caption">
				{R.toUpper(label)}
			</Typography>
            <Typography component="label" color="primary">
				{R.toUpper(value)}
			</Typography>
        </Box>
    );
};

export const SubscriptionStatus = ({ subscriptionStatus }) => {
	const { start_date, status } =
		getStatusInfoFromSubscriptionOrSchedule(subscriptionStatus);

	const isFuture = isAfter(new Date(start_date), new Date());
	return (
        <Box
			sx={[column, {
				alignItems: 'flex-end',
				mb: 4
			}]}>
            <StatusValue
				sx={{
					mb: 1
				}}
				label="Status"
				value={status}
			/>
            {!R.isEmpty(subscriptionStatus) && (
				<StatusValue
					label={`Active ${isFuture ? 'from' : 'since'}`}
					value={start_date}
				/>
			)}
        </Box>
    );
};
